import React from 'react';
import { Link } from 'react-router-dom';
import pagePath from '../../util/constants/pagePath';
import { imagePath } from '../../util/urlConfig';
import './footer.css';

const Footer = ({ showContactAndQuickLinks = true }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {showContactAndQuickLinks ? (
        <div className="footer-container">
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>iVox Learning Inc.</p>
            <p>1314 Pauline Drive, Sunnyvale, CA 94087, USA</p>
            <p>
              <a href="mailto:support@wannapractice.com" className="contact-link">
                <img
                  src={imagePath('/icon/mail.svg')}
                  className="footer-icon-unique"
                  alt="Email Icon"
                />
                support@wannapractice.com
              </a>
            </p>
          </div>
          <div className="footer-policy-section">
            <h3>Policies</h3>
            <Link to={pagePath.terms_and_conditions} className="policy-link">
              Terms of Use
            </Link>
            <Link to={pagePath.privacy_policy} className="policy-link">
              Privacy Policy
            </Link>
            <Link to={pagePath.cookie_policy} className="policy-link">
              Cookie Policy
            </Link>
          </div>
          <div className="footer-links">
            <h3>Support Links</h3>
            <div className="footer-social-wrapper">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/company/wannapractice-cybersecurity/"
                    className="quick-link"
                    aria-label="LinkedIn"
                  >
                    <img
                      src={imagePath('/icon/linkedin.svg')}
                      className="footer-icon-unique"
                      alt="LinkedIn"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/Wanna_Practice?t=KeBhJAxa0_hZFfOohB3Now&s=31"
                    className="quick-link"
                    aria-label="X"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      focusable="false"
                      className="footer-icon-unique"
                      style={{ display: 'block' }}
                    >
                      <circle cx="24" cy="24" r="24" fill="#111111"></circle>
                      <path
                        d="M14 14L22.7 25.6L14.3 34H18.5L24.6 27.6L29.4 34H34L25 21.9L33 14H28.8L23.3 19.8L19 14H14Z"
                        fill="#FFFFFF"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="footer-simple-policies">
          <Link to={pagePath.terms_and_conditions} className="simple-policy-link">
            Terms of Use
          </Link>
          <Link to={pagePath.privacy_policy} className="simple-policy-link">
            Privacy Policy
          </Link>
          <Link to={pagePath.cookie_policy} className="simple-policy-link">
            Cookie Policy
          </Link>
        </div>
      )}
      <div className="footer-bottom">
        <p>
          &copy; {currentYear} iVox Learning Inc, All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
